/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.14.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../../../theme';

export const SubscriberIdPersonalDataStyled = styled.div`
    .personal-data__status .subscriber-id__title.subscriber-id__title_light {
        ${fonts.textMainBold};
    }

    .personal-data__status {
        margin-bottom: 32px;
    }
`;
